import { render, staticRenderFns } from "./ui-alert.vue?vue&type=template&id=546b8c4e&lang=pug&"
import script from "./ui-alert.vue?vue&type=script&lang=js&"
export * from "./ui-alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('546b8c4e')) {
      api.createRecord('546b8c4e', component.options)
    } else {
      api.reload('546b8c4e', component.options)
    }
    module.hot.accept("./ui-alert.vue?vue&type=template&id=546b8c4e&lang=pug&", function () {
      api.rerender('546b8c4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/ui-pages/ui-alert.vue"
export default component.exports